import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { sendSingleReportFixedCacheKey } from "../../utils/constants/fixedCacheKeys";
import { reportsDataSelector } from "../../selector/reportsDataSelector";
import { RootState } from "@/store/store";
import { formatNotificationsFromHtmlToSlack } from "@/components/utils/helpers/slack-formatters/formatNotificationsFromHtmlToSlack";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { enqueueSendReportSnackbar } from "@/components/pages/common/send-report/components/EnqueueSendReportSnackbar";
import { oneTimeReportDetailsSelector } from "@/store/reports/selector/one-time/oneTimeReportDetailsSelector";

export const sendOneTimeReportThunk = createAsyncThunk(
  "reports/sendSingleReport",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { postUsersMeOrganisationsCurrentReportsOneTime } =
      cloudChiprApi.endpoints;

    const { export_file_types, emails, notifications, source_type, source_id } =
      reportsDataSelector(state);
    const { includeExplainAi, subject } = oneTimeReportDetailsSelector(state);

    try {
      const response = await dispatch(
        postUsersMeOrganisationsCurrentReportsOneTime.initiate(
          {
            oneTimeReport: {
              source_type,
              source_id,
              file_types: export_file_types,
              notifications:
                formatNotificationsFromHtmlToSlack(notifications) ?? null,
              emails,
              subject,
              include_explain_ai: includeExplainAi,
            },
          },
          {
            fixedCacheKey: sendSingleReportFixedCacheKey,
          },
        ),
      ).unwrap();

      enqueueSendReportSnackbar("Your request is being processed...");

      return response;
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
